/*
 * Copyright (c) 2023 Limpide
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy of
 *  this software and associated documentation files (the "Software"), to deal in
 *  the Software without restriction, including without limitation the rights to
 *  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 *  the Software, and to permit persons to whom the Software is furnished to do so,
 *  subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in all
 *  copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 *  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 *  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 *  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 *  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import Base from '@scripts/components/base'
import Marquer from '@scripts/marquer'

export default class PostListing extends Base {
    element: HTMLElement
    button: HTMLButtonElement | null
    wrapper: HTMLDivElement | null
    page: number = 2
    loading: boolean = false
    data_layer: {
        type_page: Array<{ valeur: string; page: string; terme: string }>
        page_category: Array<{ valeur: string; type: string; page: string; terme: string }>
        cta_name: Array<{
            valeur: string
            section: string
            type: string
            urlExterne: string
            page: string
            terme: string
        }>
        site_section: Array<{ valeur: string; section: string }>
    }

    constructor(element: HTMLElement) {
        super()

        this.data_layer = window.layerData.data_layer
        this.element = element
        this.button = element.querySelector('.load-more')
        this.wrapper = element.querySelector('.post-listing-wrapper')
    }

    start() {
        const category = this.button?.dataset.category
        const pagination = this.button?.dataset.pagination

        this.button?.addEventListener('click', () => {
            this.element.classList.add('is-loading')

            if (!this.loading) {
                this.loading = !this.loading

                const body = new FormData()

                body.append('action', 'load_more')
                body.append('page', this.page.toString())

                category && body.append('category', category)

                fetch(window.maratp.request_uri, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body
                })
                    .then(async (response: Response) => {
                        this.loading = !this.loading
                        this.element.classList.remove('is-loading')

                        if (response.status === 200) {
                            const data = await response.text()

                            ++this.page
                            this.wrapper?.insertAdjacentHTML('beforeend', data)
                            pagination && this.page > parseInt(pagination) && this.element.classList.add('is-full')

                            if (this.data_layer) {
                                const marquers: Marquer = new Marquer(this.data_layer)

                                marquers.post_listing()
                            }
                        } else {
                            this.element.classList.remove('is-full')
                            console.warn(response.statusText || 'Unable to load more posts.')
                        }
                    })
                    .catch(error => () => {
                        this.element.classList.remove('is-full')
                        console.log('x', error)
                    })
            }
        })
    }
}
